import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import useDate from '../../hooks/app/useDate'
import isEmpty from 'lodash/isEmpty'
import { optionListGender } from '../FormControl/SelectCustom/SelectFieldGender'
import FormatDate from '../date/FormatDate'

const ItemFilter = ({ module, code, value, onDelete }) => {
  let codeName = code
  let val = <span className='capitalize'>{value}</span>

  if (typeof value === 'boolean') {
    val = <span>{value ? 'Yes' : 'No'}</span>
  }

  if (typeof value === 'object') {
    val = <span>{value?.name || value?.label}</span>
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      val = <></>
    } else if (typeof value[0] === 'object' && value[0] !== null) {
      // Array of objects
      val = <>{value.map((v) => v?.name).join(', ')}</>
    } else {
      // Array of primitives
      val = <>{value.join(', ')}</>
    }
  }

  const isDate = code.indexOf('Date') !== -1 || code instanceof Date
  const dateKeys = ['startDate', 'endDate', 'date', 'lastLogin']
  if (dateKeys.includes(code) || isDate) {
    val = <FormatDate date={value.start} />
  }
  if (['importName', 'importId'].includes(code)) {
    codeName = 'Import name'
  }
  if (code === 'moduleId') {
    codeName = 'Module'
  }
  if (code === 'actionId') {
    codeName = 'Action'
  }
  if (code === 'isLinked') {
    codeName = 'Is linked'
    val = <span>{value === 'yes' ? 'Yes' : 'No'}</span>
  }
  if (code === 'isActived') {
    codeName = 'Is Active'
    val = <span>{value === 'yes' ? 'Yes' : 'No'}</span>
  }
  if (code === 'studentCode') {
    codeName = 'Code'
  }
  if (code === 'studentFirstName') {
    codeName = 'First Name'
  }
  if (code === 'studentLastName') {
    codeName = 'Last Name'
  }
  if (code === 'studentHouse') {
    codeName = 'House'
  }
  if (code === 'studentForm') {
    codeName = 'Form'
  }

  if (['template'].includes(code)) {
    val = (
      <>
        {value.map((item, i) => (
          <Chip size='small' key={`${code}-${i}`} label={item.name || item.title} />
        ))}
      </>
    )
  }
  if (['roles', 'yearLevel', 'teachers', 'classes', 'unit of learning', 'flag'].includes(code)) {
    val = (
      <>
        {value.map((item, i) => (
          <Chip size='small' key={`${code}-${i}`} label={item.name || item.label} />
        ))}
      </>
    )
  }

  if (code === 'gender') {
    val = <>{optionListGender?.find((op) => op.value === value)?.label}</>
  }
  if (code === 'lcElements_name') {
    return Object.keys(value).map((key, i) => (
      <Chip
        variant='outlined'
        key={`id-${key}-${i}`}
        label={
          <div className='flex items-center gap-1'>
            <Typography
              color='primary'
              className='text-xs uppercase font-bold'
              variant='inherit'
              component={'b'}
            >
              {value[key].name}:{' '}
            </Typography>
            {value[key].value}
          </div>
        }
        onDelete={['startDate', 'endDate'].includes(code) ? undefined : () => onDelete(`${code}-${key}`)}
      />
    ))
  }
  if (code === 'yearLevel_name') {
    codeName = 'Year Level'
  }
  if (code === 'subjectId_name') {
    codeName = 'Subject'
  }
  if (['curriculumElements', 'curriculumelements'].includes(code)) {
    codeName = 'Curriculum Elements'
  }
  if (code === 'periodStartDate' || code === 'startDate') {
    codeName = 'Start Date'
  }
  if (code === 'periodEndDate' || code === 'endDate') {
    codeName = 'End Date'
  }
  if (code === 'rangeExpireAt' || code === 'rangePublishedAt') {
    codeName = code === 'rangeExpireAt' ? 'Expire At' : 'Published at'
    let start = value.start
    let end = value.end
    if (start) {
      start = <FormatDate date={value.start} />
    }
    if (end) {
      end = <FormatDate date={value.end} />
    }
    val = (
      <>
        {start && <>{start} </>}
        {end && <>- {end}</>}
      </>
    )
  }

  if (['yearLevel_name'].includes(code)) {
    val = (
      <>
        {value.map((role, i) => (
          <Chip size='small' key={`${code}-${i}`} label={role.name} />
        ))}
      </>
    )
  }
  if (['curriculumElements', 'curriculumelements'].includes(code)) {
    if (
      ['analyticsClasses', 'class', 'dr', 'gantt', 'drGroupedByLearningContinuum', 'subject'].includes(module)
    ) {
      return Object.keys(value)
        .filter((key) => value[key])
        .map((key, i) => (
          <Chip
            key={`id-${key}-${i}`}
            variant='outlined'
            label={
              <div className='flex items-center gap-1'>
                <Typography
                  color='primary'
                  className='text-xs uppercase font-bold'
                  variant='inherit'
                  component={'b'}
                >
                  {value[key]?.keyName}:{' '}
                </Typography>
                {Array.isArray(value[key]?.valueName)
                  ? value[key]?.valueName?.join(', ')
                  : value[key]?.valueName || ''}
              </div>
            }
            onDelete={() => onDelete(`${code}-${key}`)}
          />
        ))
    }
    const RenderChip = ({ id, value, isDeleted, code }) =>
      isEmpty(value?.find) ? (
        <> </>
      ) : (
        <>
          <Chip
            variant='outlined'
            label={
              <div className='flex items-center gap-1'>
                <Typography
                  color='primary'
                  className='text-xs uppercase font-bold'
                  variant='inherit'
                  component={'b'}
                >
                  {value?.name}:{' '}
                </Typography>
                {Array.isArray(value?.find)
                  ? value?.find?.map((v) => v.name).join(', ')
                  : value?.find?.name || ''}
              </div>
            }
            onDelete={isDeleted ? () => onDelete(`${code}-${id}`) : undefined}
          />
          {Object.keys(value?.children || {})?.map((key, i) => (
            <RenderChip
              key={`id-${id}-${key}-${i}`}
              id={key}
              code={`${code}-${id}`}
              isDeleted={true}
              value={value?.children ? value?.children[key] : {}}
            />
          ))}
        </>
      )

    return Object.keys(value).map((key, i) => (
      <RenderChip key={`${key}-${i}`} id={key} value={value[key]} isDeleted={true} code={code} />
    ))
  }

  if (code === 'user') {
    val = <span>{value?.label}</span>
  }

  return (
    <Chip
      variant='outlined'
      label={
        <div className='flex items-center gap-1'>
          <Typography
            color='primary'
            className='text-xs uppercase font-bold'
            variant='inherit'
            component={'b'}
          >
            {codeName}:{' '}
          </Typography>
          {val}
        </div>
      }
      onDelete={
        ['startDate', 'endDate'].includes(code) && !['learningMatrix'].includes(module)
          ? undefined
          : () => onDelete(code)
      }
    />
  )
}

export default ItemFilter
